/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { CommonDropdownWithLabel } from './common-dropdown-with-label';
import { filterProperties } from 'utilities/srsUtils';

const nullableProperty = {
	name: 'None',
	propertyId: -1,
};

const emptyText = 'Select a property';

const toProperty = (selectedDefinition, isNullable, toCheck) => {
	if (!toCheck) {
		return isNullable ? nullableProperty : emptyText;
	}

	if (!toCheck.name) {
		const name = toCheck;
		return Object.values(selectedDefinition.propertyList)?.find((property) => property.name === name) ?? null;
	}

	return toCheck;
};

/**
 *
 * @param selectedDefinition
 * @param onSelectionChanged
 * @param activeItem
 * @param flags
 * @param types
 * @param label
 * @param isNullable
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
export function PropertyDropdown({
	selectedDefinition,
	onSelectionChanged,
	activeItem,
	flags,
	types,
	allowedProperties,
	isNullable = false,
	...rest
}) {
	const optionToString = (x) => x?.name || x || '';

	let filteredProperties = filterProperties(selectedDefinition.name, flags, types, allowedProperties);

	if (isNullable) {
		filteredProperties.unshift(nullableProperty);
	}

	const changeHandler = useCallback(
		(item) => {
			if (item.propertyId === -1) {
				onSelectionChanged(null);
			} else {
				onSelectionChanged(item);
			}
		},
		[onSelectionChanged]
	);

	return (
		<CommonDropdownWithLabel
			options={filteredProperties}
			onSelectionChanged={changeHandler}
			activeItem={toProperty(selectedDefinition, isNullable, activeItem)}
			optionToString={optionToString}
			emptyText={emptyText}
			btnText={optionToString(toProperty(selectedDefinition, isNullable, activeItem)) || emptyText}
			{...rest}
		/>
	);
}

PropertyDropdown.propTypes = {
	selectedDefinition: PropTypes.any,
	activeItem: PropTypes.any,
	flags: PropTypes.any,
	label: PropTypes.string,
	onSelectionChanged: PropTypes.any,
	types: PropTypes.any,
	isNullable: PropTypes.bool,
};
